import { Component, Input} from '@angular/core';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { PartnerAnalysisGroup1 } from 'src/app/assabil-kernel/models/entities/control-tables/partner-analysis-group1';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
    selector: 'partner-analysis-group1-lov',
    templateUrl: './partner-analysis-group1-lov.component.html',
    styleUrls: ['./partner-analysis-group1-lov.component.scss']
})


export class PartnerAnalysisGroup1LovComponent extends GenericLovComponent   {

    @Input() code         : string; 
    @Input() name         : string; 

    partnerAnalysisGroup1s: PartnerAnalysisGroup1[] = [];

    columns = [
        {  prop: 'partnerAnalysisGroup1Code', name: 'Code'},
        {  prop: 'name', name: 'Nom'}
    ]


//----------------------------------------------------------------------
constructor( 
    public dialogRef: MatDialogRef<PartnerAnalysisGroup1LovComponent>,
    protected controlTablesService  : ControlTablesService) {
    super();
    this.entityName = "partnerAnalysisGroup1";
}
//----------------------------------------------------------------------
    


//----------------------------------------------------------------------
loadData() {
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlTablesService.getList(this.entityName, request).then(result => {
        this.partnerAnalysisGroup1s = result;
    })
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
closeModal(partnerAnalysisGroup1 : PartnerAnalysisGroup1){
    this.dialogRef.close(partnerAnalysisGroup1);
}
//----------------------------------------------------------------------


}
